import { common, formData } from '../constants/actions'

const initialState = {
  showLoadingIndicator: false,
  startTimer: false,
  reset: false,
  loadingIndicatorContent: null,
  systemAlert: {},
}

export const getTimerReset = state => state.reset

export default (state = initialState, action) => {
  switch (action.type) {
    case common.SET_SHOW_LOADING_INDICATOR:
      return {
        ...state,
        showLoadingIndicator: action.payload,
      }
    case common.SET_START_TIMER:
      return {
        ...state,
        startTimer: action.payload,
      }
    case common.RESET_TIMER:
      return {
        ...state,
        reset: !state.reset,
      }
    case formData.RESET_FORM:
      return { ...initialState }
    case common.SET_LOADING_INDICATOR_CONTENT:
      return {
        ...state,
        loadingIndicatorContent: action.payload,
      }
    case common.SET_SYSTEM_ALERT:
      return {
        ...state,
        systemAlert: action.payload,
      }
    default:
      return state
  }
}
